(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-helpful-add-on]';

  function initializeHelpfulAddOn(root) {
    if (!root || root.getAttribute('data-helpful-add-on-initialized') === 'true') return;

    var formId = root.getAttribute('data-product-form-id');
    var form = formId ? document.getElementById(formId) : root.closest('form');
    if (!form) return;

    root.setAttribute('data-helpful-add-on-initialized', 'true');

    var toggle = root.querySelector('[data-helpful-add-on-toggle]');
    var variants = Array.prototype.slice.call(root.querySelectorAll('[data-helpful-add-on-variant]'));
    var price = root.querySelector('[data-helpful-add-on-price]');
    var total = root.querySelector('[data-helpful-add-on-total]');
    var totalPrice = root.querySelector('[data-helpful-add-on-total-price]');
    var error = root.querySelector('[data-helpful-add-on-error]');
    var productForm = form.closest('product-form');
    var productInfo = form.closest('product-info');
    var variantPicker = productInfo ? productInfo.querySelector('variant-picker') : null;
    var mainVariantPending = false;
    var mainVariantResolved = false;
    var submitting = false;

    if (productForm) productForm.classList.add('helpful-add-on-present');

    function selectedVariant() {
      var selected = variants.find(function (variant) {
        return variant.type === 'hidden' || variant.checked;
      });

      if (selected && !selected.disabled) return selected;

      return variants.find(function (variant) {
        return !variant.disabled;
      });
    }

    function syncVariant(changedVariant) {
      if (changedVariant && changedVariant.type === 'radio') {
        variants.forEach(function (variant) {
          if (variant !== changedVariant && variant.type === 'radio') variant.checked = false;
        });
      }

      var selected = selectedVariant();
      if (selected && selected.getAttribute('data-price')) {
        if (price) price.textContent = selected.getAttribute('data-price');
        if (totalPrice) totalPrice.textContent = selected.getAttribute('data-price');
      }
    }

    function clearError() {
      if (!error) return;
      error.hidden = true;
      error.textContent = '';
    }

    function showError(message) {
      if (!error) return;
      error.textContent = message;
      error.hidden = false;
    }

    function syncToggle() {
      var active = Boolean(toggle && toggle.checked);
      root.classList.toggle('is-selected', active);
      if (productForm) productForm.classList.toggle('helpful-add-on-active', active);
      if (total) total.hidden = !active;
      clearError();
    }

    function getMainVariantId() {
      var mainVariantInput = form.querySelector('input[name="id"], select[name="id"]');
      var inputValue = mainVariantInput && mainVariantInput.value;

      if (inputValue) return inputValue;
      if (mainVariantPending || mainVariantResolved) return '';

      return root.getAttribute('data-main-variant-id') || '';
    }

    function getMainQuantity() {
      var quantityInput = form.querySelector('input[name="quantity"]');
      var quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;
      return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
    }

    function setLoading(loading) {
      if (productForm && typeof productForm.toggleSpinner === 'function') {
        productForm.toggleSpinner(loading);
      }
    }

    function updateCart(response) {
      var settings = window.MinimogSettings || {};
      var events = window.MinimogEvents;
      var theme = window.MinimogTheme;

      if (settings.use_ajax_atc === false) {
        window.location.href = settings.routes && settings.routes.cart ? settings.routes.cart : '/cart';
        return;
      }

      if (productForm && productForm.cart && settings.enable_cart_drawer) {
        if (
          theme &&
          theme.Notification &&
          window.MinimogStrings &&
          productForm.cart.querySelector('m-cart-items')
        ) {
          theme.Notification.show({
            target: productForm.cart.querySelector('m-cart-items'),
            method: 'prepend',
            type: 'success',
            message: window.MinimogStrings.itemAdded,
            delay: 400
          });
        }
        productForm.cart.open();
      }

      if (events && theme && theme.pubSubEvents && theme.pubSubEvents.cartUpdate) {
        events.emit(theme.pubSubEvents.cartUpdate, { cart: response });
      } else {
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
      }

      document.dispatchEvent(
        new CustomEvent('product-ajax:added', {
          detail: {
            product: response
          }
        })
      );
    }

    variants.forEach(function (variant) {
      variant.addEventListener('change', function () {
        syncVariant(variant);
      });
    });

    if (toggle) toggle.addEventListener('change', syncToggle);

    form.addEventListener('change', function (event) {
      var target = event.target;
      if (!target || !target.matches('input[name="id"], select[name="id"]')) return;

      mainVariantResolved = true;
      mainVariantPending = false;
      root.setAttribute('data-main-variant-id', target.value || '');
      clearError();
    });

    if (productInfo) {
      productInfo.addEventListener(
        'change',
        function (event) {
          var target = event.target;
          var picker = target && target.closest ? target.closest('variant-picker') : null;
          if (!picker || !productInfo.contains(picker)) return;

          mainVariantPending = true;
          mainVariantResolved = false;
          root.setAttribute('data-main-variant-id', '');
          clearError();
        },
        true
      );
    }

    form.addEventListener(
      'submit',
      function (event) {
        if (!toggle || !toggle.checked) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        if (submitting) return;

        if (mainVariantPending) {
          showError('Please wait while your product selection updates.');
          return;
        }

        var mainVariantId = getMainVariantId();
        var addOnVariant = selectedVariant();

        if (!mainVariantId) {
          showError('Please select an available product option.');
          return;
        }

        if (!addOnVariant || !addOnVariant.value) {
          showError('Please choose an available tool size.');
          return;
        }

        clearError();
        submitting = true;
        setLoading(true);

        var sectionsToBundle = [];
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:grouped-sections', {
            bubbles: true,
            detail: {
              sections: sectionsToBundle
            }
          })
        );

        sectionsToBundle = Array.from(
          new Set(
            sectionsToBundle.filter(function (sectionName) {
              return Boolean(sectionName);
            })
          )
        );

        var settings = window.MinimogSettings || {};
        var route = settings.routes && settings.routes.cart_add_url ? settings.routes.cart_add_url : '/cart/add.js';
        var payload = {
          items: [
            {
              id: mainVariantId,
              quantity: getMainQuantity()
            },
            {
              id: addOnVariant.value,
              quantity: 1
            }
          ],
          sections: sectionsToBundle,
          sections_url: window.location.pathname
        };

        fetch(route, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(payload)
        })
          .then(function (response) {
            return response.json().then(function (body) {
              return {
                ok: response.ok,
                body: body
              };
            });
          })
          .then(function (result) {
            if (!result.ok || result.body.status || result.body.errors) {
              throw new Error(result.body.description || result.body.message || result.body.errors || 'Unable to add both items.');
            }
            updateCart(result.body);
          })
          .catch(function (requestError) {
            showError(requestError.message || 'Unable to add both items.');
          })
          .finally(function () {
            submitting = false;
            setLoading(false);
          });
      },
      true
    );

    syncVariant();
    syncToggle();
  }

  function initializeAll(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    context.querySelectorAll(ROOT_SELECTOR).forEach(initializeHelpfulAddOn);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeAll(document);
    });
  } else {
    initializeAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target);
  });
})();
